import React from "react";

// Shared Enter/Space -> click handler for the mouse-only clickable rows across
// the onward-travel surfaces (End-to-end Journey drawer, per-leg checkout
// accordion, JourneyOptionsPanel).
export const onActivateKey = (onClick: () => void) => (event: React.KeyboardEvent) => {
  if (event.key === "Enter" || event.key === " ") {
    // preventDefault: without it the same Enter keystroke carries through and
    // activates the modal's autofocused Close button, snapping it shut again
    // (also stops Space from scrolling the page).
    event.preventDefault();
    onClick();
  }
};
